<template>
  <div class="ebDateTimePicker">
    <div class="eb-datepicker">
      <el-date-picker v-model="dateValue" type="date" :disabled="disabled" :format="dateFormat" :placeholder="datePlaceholder" :editable="editable" size="small" @change="dateChange" :clearable='false'>
      </el-date-picker>
    </div>
    <div class="datetimeline" v-show="timeOption"></div>
    <div class="eb-timepicker" v-show="timeOption">
      <el-time-select @change="timeChange" v-model="timeValue" :disabled="disabled" :picker-options="timePickerPickerOptions" placeholder="选择时间" size="small" :clearable='false' :editable="editable">
      </el-time-select>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'ebOrgDateTimePicker',
  props: {
    time: {},
    dateFormat: String,
    datePlaceholder: String,
    editable: Boolean,
    timeOption: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      timeValue: '',
      dateValue: '',
      timePickerPickerOptions: {
        default: function() {
          return {
            start: '00:00',
            step: '01:00',
            end: '24:00'
          };
        }
      }
    };
  },
  watch: {
    time: {
      handler: function(newVal, old) {
        var time = Number(newVal);
        this.dateValue = moment(time).format('YYYY-MM-DD');
        this.timeValue = moment(time).format('HH:mm');
      },
      deep: true
    }
  },
  created() {
    if (this.time) {
      var time = Number(this.time);
      this.dateValue = moment(time).format('YYYY-MM-DD');
      this.timeValue = moment(time).format('HH:mm');
    }
  },
  methods: {
    timeChange: function(newVal) {
      var time = Number(moment(this.dateValue + ' ' + newVal).format('x'));
      this.$emit('update:time', time);
    },
    dateChange: function(newVal) {
      var time = moment(newVal).format('YYYY-MM-DD');
      if (this.timeValue) {
        time = moment(newVal).format('YYYY-MM-DD') + ' ' + this.timeValue;
      }
      time = Number(moment(time).format('x'));
      this.$emit('update:time', time);
    }
  }
};
</script>
<style scoped lang="less">
.ebDateTimePicker {
  display: flex;
  flex-wrap: wrap;
}
.eb-datepicker {
  width: 174px;
}
.eb-timepicker {
  width: 123px;
}
.datetimeline {
  height: 20px;
  width: 1px;
  border-left: 1px solid red;
  margin: 5px 10px;
}
</style>
